//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import * as competitorsApi from '@apis/instagram-competitors/instagramCompetitorsApi';

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate').service('TrackedSourcesService', [
    '$log',
    'SessionVarsService',
    'TrackedSourcesApiService',
    'rx',
    'TRACKED_SOURCES_ACTIONS',
    function(
            $log,
            SessionVarsService,
            TrackedSourcesApiService,
            rx,
            TRACKED_SOURCES_ACTIONS,
        ) {
      const initialState = {
        trackedSources: {
          users: [],
          hashtags: [],
        },
      };

      const updates = new rx.ReplaySubject(1);
      const trackedSourcesState = updates.scan((state, action) => {
        const newState = angular.copy(state);
        switch (action.type) {
          case TRACKED_SOURCES_ACTIONS.REFRESH_TRACKED_SOURCES:
            newState.trackedSources = action.trackedSources;
            break;
          default:
            $log.error(`unrecognized action type: ${action.type}`);
            break;
        }
        return newState;
      }, initialState);

      this.getTrackedSourcesState = function() {
        return trackedSourcesState.asObservable();
      };

      this.refresh = function() {
        rx.Observable.fromPromise(TrackedSourcesApiService.getAllTrackedSources()).subscribe(async (response) => {
          _(response.businessUsers).each((businessUser) => {
            businessUser.isTrackedBusinessUser = true;
          });

          const businessUserNames = _(response.businessUsers).pluck('name');
          const filteredTrackedUsers = _(response.users).reject((user) => {
            return _(businessUserNames).contains(user.name);
          });

          const compoundSources = _(response.businessUsers).union(filteredTrackedUsers);

          response.users = compoundSources;

          if (SessionVarsService.isFeatureEnabled('instagram_competitors')) {
            const trackedCompetitors = await competitorsApi.getCompetitors();

            const renamedTrackedCompetitors = trackedCompetitors.map((trackedCompetitor) => {
              return {
                name: trackedCompetitor.username,
                id: trackedCompetitor.id,
              };
            });

            response.competitors = renamedTrackedCompetitors;
          }

          updates.next({
            type: TRACKED_SOURCES_ACTIONS.REFRESH_TRACKED_SOURCES,
            trackedSources: response,
          });
        });
      };

            // initialize the service
      this.refresh();
    },
  ]);
})();
